/* @flow */
import Entity from 'lib/Entity';

export default class LinkPreview extends Entity {
  parse(response: Object) {
    const data = Object.assign({}, response);

    if (response.imageUrl) {
      data['image'] = response.imageUrl;
    }

    return data;
  }

  getTitle(): string {
    return this.get('title');
  }

  getDescription(): string {
    return this.get('description');
  }

  getImageUrl(): string {
    return this.get('image');
  }

  getImageWidth(): string {
    return this.get('image_width');
  }

  getImageHeight(): string {
    return this.get('image_height');
  }

  getRichContentType(): string {
    return this.get('rich_content_type');
  }

  getRichContentUrl(): string {
    return this.get('rich_content_url');
  }

  getUrl(): string {
    return this.get('url');
  }

  toGraphQL(): * {
    return {
      title: this.getTitle(),
      description: this.getDescription(),
      url: this.getUrl(),
      imageUrl: this.getImageUrl(),
    };
  }
}
